import axios from './index';

export const getIsfFiles = async (clinicalTrialId) => {
    return axios.get(`api/v1/startups/${clinicalTrialId}/files`);
};

export const updateAttachmentPathsSubtitlesBatch = async (startupId, subtitles) => {
    return axios.post(`api/v1/startups/${startupId}/files/subtitles`, {
        subtitles: (subtitles || []).map(({ path, subtitle }) => ({ path, subtitle: subtitle || "" })),
    });
};

export const getNotifications = async (startupId) => {
    return axios.get(`api/v1/startups/notifications/${startupId}`);
};

export const testNotifications = async (request) => {
    return axios.post(`api/v1/notifications/SendEmailNotification`, request);
};


export const getPagingAndOrderParams = (newActiveFilters, searchParams) => {

    if (!newActiveFilters)
        return;

    searchParams.delete('pageIndex'); // se resetea el paginado
    if (newActiveFilters.pagination?.page) {
        searchParams.append('pageIndex', newActiveFilters.pagination.page);
    }
    searchParams.delete('pageSize');
    if (newActiveFilters.pagination?.sizePerPage) {
        searchParams.append('pageSize', newActiveFilters.pagination.sizePerPage);
    }
    searchParams.delete('sortField');
    if (newActiveFilters.sort?.sortField) {
        searchParams.append('sortField', newActiveFilters.sort.sortField);
    }
    searchParams.delete('sortOrder');
    if (newActiveFilters.sort?.sortOrder) {
        searchParams.append('sortOrder', newActiveFilters.sort.sortOrder);
    }

    return searchParams;
}

export const getQueryString = (query, search) => {

    var searchParams = new URLSearchParams(search || '');

    if (!query)
        return searchParams.toString();

    searchParams = getPagingAndOrderParams(query, searchParams);

    if (query.filters) {
        for (const property in query.filters) {

            searchParams.delete(property);
            if (query.filters[property] !== null && query.filters[property] !== undefined) {
                searchParams.append(property, query.filters[property]);
            }
        }
    }

    searchParams.delete('q');
    if (query.query) {
        searchParams.append('q', query.query);
    }

    return searchParams.toString();
}

//#region Admin
export const getMasterData = (items) => {
    const itemsParams = new URLSearchParams(window.location.search || '');
    itemsParams.delete('items');
    items.forEach(item => itemsParams.append('items', item));
    return axios.get(`api/v1/protocols/selectmasterdata?${itemsParams}`);
};

export const getStudyTasks = (protocolId) => {
    return axios.get(`api/v1/protocols/${protocolId}/studyTasks`);
};
//#endregion


//#region ClinicalTrials
export const getClinicalTrials = async (filters, regulatorySubmissionsOnly) => {
    let queryString = getQueryString(filters, window.location.search);

    if (regulatorySubmissionsOnly) {
        queryString += queryString ? `&regulatoryOnly=true` : `regulatoryOnly=true`;
    }
    
    return axios.get(queryString ? `api/v1/startups/?${queryString}` : `api/v1/startups`);
};

export const getClinicalTrial = async (clinicalTrialId) => {
    return axios.get(`api/v1/startups/${clinicalTrialId}`);
};
export const createClinicalTrial = async (protocol) => {
    return axios.post(`api/v1/startups`, protocol);
};
export const updateClinicalTrial = async (startup) => {
    if (!startup?.id) {
        return;
    }
    return axios.put(`api/v1/startups/${startup?.id}`, startup);
};
export const getClinicalTrialCompetitors = async (clinicalTrialId) => {
    return axios.get(`api/v1/startups/${clinicalTrialId}/competitors`);
};
export const uploadAttachment = async (typeId, categoryId, entityId, file, extendedMetadata) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("extendedMetadata", JSON.stringify(extendedMetadata));

    return axios.post(`api/v1/attachments/${typeId}/${categoryId}/${entityId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const saveEditedCategories = async (data) => {
  return axios.post(`api/v1/attachments/editCategories`, data);
};
export const saveNewCategory = async (data) => {
  return axios.post(`api/v1/attachments/createCategory`, data);
};
export const updateNotificationsConfig = async (notificationsConfig) => {
    if (!notificationsConfig[0]?.startupId) {
        return;
    }
    return axios.put(`api/v1/startups/notifications/${notificationsConfig[0]?.startupId}`, notificationsConfig);
};
export const uploadAttachmentMetadata = async (entityTypeId, attachmentId, extendedMetadata) => {
  return axios.put(
    `api/v1/attachments/${entityTypeId}/${attachmentId}/metadata`,
    JSON.stringify(extendedMetadata),
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

// api/attachmentSlot

export const buildSlotKey = (typeId, categoryId, entityId) =>
  `${typeId}|${categoryId}|${entityId}`;

export async function fetchSlotStateBatch(items) {
  // items: [{ typeId, categoryId, entityId, sinceUtc }]
  const { data } = await axios.post(`/api/v1/attachments/state/batch`, {
    items: items.map((x) => ({
      typeId: x.typeId,
      categoryId: x.categoryId,
      entityId: x.entityId,
      sinceUtc: x.sinceUtc || null,
    })),
  });
  return data;
}

export async function postSlotMessage(typeId, categoryId, entityId, payload) {
  const { data } = await axios.post(
    `/api/v1/attachments/${typeId}/${categoryId}/${encodeURIComponent(entityId)}/messages`,
    payload
  );
  return data;
}

export async function markRequired(typeId, categoryId, entityId, attachmentId) {
  const qs = attachmentId ? `?attachmentId=${attachmentId}` : "";
  const { data } = await axios.post(
    `/api/v1/attachments/${typeId}/${categoryId}/${encodeURIComponent(entityId)}/required${qs}`
  );
  return data;
}

export async function downloadAttachmentsZip(items, zipFileName = "documentos_isf.zip") {
  const payload = {
    items: (items || [])
      .filter((x) => x?.attachmentId > 0)
      .map((x) => ({
        typeId: x.typeId,
        attachmentId: x.attachmentId,
        folderName: x.folderName,
      })),
  };

  const response = await axios.post(`/api/v1/attachments/download/zip`, payload, {
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", zipFileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function markRequiredBatch(items) {
  const payload = {
    items: (items || []).map((x) => ({
      typeId: x?.typeId,
      categoryId: x?.categoryId,
      entityId: x?.entityId,
      attachmentId: x?.attachmentId ?? null,
    })),
  };

  const { data } = await axios.post(`/api/v1/attachments/required/batch`, payload);
  return data;
}

export async function unmarkRequired(typeId, categoryId, entityId) {
  await axios.delete(
    `/api/v1/attachments/${typeId}/${categoryId}/${encodeURIComponent(entityId)}/required`
  );
}

export async function markSlotRead(typeId, categoryId, entityId, payload) {
    const { data } = await axios.post(
      `/api/v1/attachments/${typeId}/${categoryId}/${encodeURIComponent(entityId)}/messages/read`,
      payload
    );
    return data;
}

// end api/attachmentSlot

export const getRegulatoryEvents = async (protocolId) => {
    if (!protocolId) {
        return;
    }
    return axios.get(`api/v1/protocols/${protocolId}/regulatory-submissions?pageSize=100`);
};

export const getCreateRegulatoryEvents = async (protocolId) => {
    if (!protocolId) {
        return;
    }
    return axios.get(`api/v1/protocols/${protocolId}/regulatory-submissions/create`);
};

export const createRegulatoryEvent = async (protocolId, formData) => {
    if (!protocolId) {
        return;
    }
    return axios.post(`api/v1/protocols/${protocolId}/regulatory-submissions`, formData);
};

export const getRegulatoryEvent = async (regulatorySubmissionId) => {
    if (!regulatorySubmissionId) {
        return;
    }
    return axios.get(`api/v1/regulatory-submissions/${regulatorySubmissionId}`);
};

export const getRegulatoryEventAttachments = async (regulatorySubmissionId, formData) => {
    if (!regulatorySubmissionId) {
        return;
    }
    return axios.post(`api/v1/regulatory-submissions/${regulatorySubmissionId}/attachments`, formData);
};

export const saveRegulatoryEvent = async (protocolId, regulatorySubmissionId, formData) => {
    if (!regulatorySubmissionId) {
        return;
    }
    return axios.put(`api/v1/protocols/${protocolId}/regulatory-submissions/${regulatorySubmissionId}`, formData);
};
export const getRegulatoryGroups = async () => {
    return axios.get(`api/v1/regulatory-submissions/groups`);
};

export const getCreateRegulatoryGroup = async () => {
    return axios.get(`api/v1/regulatory-submissions/groups/create`);
};

export const createRegulatoryGroup = async (formData) => {
    return axios.post(`api/v1/regulatory-submissions/groups`, formData);
};

export const deleteRegulatoryGroup = async (id) => {
    return axios.delete(`api/v1/regulatory-submissions/groups/${id}`);
};

export const confirmRegulatorySubmissionPatientConsents = async (protocolId, patientId, rejected, rejectedReason = null) => {
    if (!protocolId || !patientId) {
        return;
    }
    return axios.post(`api/v1/protocols/${protocolId}/regulatory-submissions/consents/${patientId}`,
        { rejected, rejectedReason });
};

export const getPractitionerAttachments = async (practitionerId) => {
    return axios.get(`api/v1/attachments/practitioners/${practitionerId}`);
};
export const getHistoryFile = async (typeId, attachmentCategoryId, entityId) => {
    return axios.get(`api/v1/attachments/history/${typeId}/${attachmentCategoryId}/${entityId}`);
};
export const getAttachments = (protocolId) => {
    return axios.get(`api/v1/attachments/${protocolId}/attachments`);
};
export const getAttachment = (typeId, attachmentId) => {
    return axios.get(`api/v1/attachments/${typeId}/${attachmentId}`, { responseType: 'blob' });
};
export const getAttachmentEndpoint = (typeId) => {
    return `api/v1/attachments/${typeId}`;
};
export const removeAttachment = (typeId, attachmentId, removeVersions = false) => {
    return axios.delete(`api/v1/attachments/${typeId}/${attachmentId}?removeVersions=${removeVersions}`);
};
export const getHospitalFiles = async () => {
    return axios.get(`api/v1/attachments/hospital-files`);
};
export const getStartupDevices = async (startupId) => {
    return axios.get(`api/v1/startups/${startupId}/devices`);
};
export const addStartupDevice = async (startupId, deviceId) => {
    return axios.post(`api/v1/startups/${startupId}/devices/${deviceId}`);
};
export const removeStartupDevice = async (startupId, deviceId) => {
    return axios.delete(`api/v1/startups/${startupId}/devices/${deviceId}`);
};
export const getPractitionersFilters = async () => {
    return axios.get(`api/v1/startups/practitioners/filters`);
};
export const getStartupsSpecialties = async () => {
    return axios.get(`api/v1/startups/filters/specialties`);
};
//#endregion